export default {"src":"//_next/static/media/arrow-right.6996d652.svg","height":24,"width":24};